/**
 * @file ClientAdminHomePage.js
 * @description Client admin portal home page.
 */

import DashboardPage from '../dashboard/DashboardPage';

function ClientAdminHomePage() {
    return <DashboardPage />;
}

export default ClientAdminHomePage;
